"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConnectedServer = /** @class */ (function () {
    function ConnectedServer(_userId, _siteId, _siteNamespace, _workbookId) {
        this._userId = _userId;
        this._siteId = _siteId;
        this._siteNamespace = _siteNamespace;
        this._workbookId = _workbookId;
    }
    Object.defineProperty(ConnectedServer.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedServer.prototype, "siteId", {
        get: function () {
            return this._siteId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedServer.prototype, "siteNamespace", {
        get: function () {
            return this._siteNamespace;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedServer.prototype, "workbookId", {
        get: function () {
            return this._workbookId;
        },
        enumerable: true,
        configurable: true
    });
    return ConnectedServer;
}());
exports.ConnectedServer = ConnectedServer;
//# sourceMappingURL=ConnectedServer.js.map